// Yopiq hujjatlar (tashkilot sozlamasi settings.privateDocuments): org/<id>/documents/ fayllari faqat
// imzolangan qisqa muddatli havola bilan ochiladi. Bayroq o'chiq bo'lsa — oddiy mediaUrl (avvalgidek).
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { mediaUrl } from './media';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';
const ORIGIN = API.replace(/\/api\/?$/, '');
const DOC_RE = /\/api\/upload\/raw\/org\/[^/]+\/documents\//;

export const isDocumentUrl = (u) => typeof u === 'string' && DOC_RE.test(u);

// imzolangan havolalar keshi (9 daqiqa — server 10 daqiqa beradi)
const cache = new Map();   // url -> { signed, at }
const TTL = 9 * 60 * 1000;

export async function signedMediaUrl(u, { download = false } = {}) {
  const hit = cache.get(u);
  let signed = hit && Date.now() - hit.at < TTL ? hit.signed : null;
  if (!signed) {
    const res = await axios.post(`${API}/upload/sign`, { urls: [u] });
    signed = res.data.urls?.[u];
    if (!signed) throw new Error('sign failed');
    cache.set(u, { signed, at: Date.now() });
  }
  return ORIGIN + signed + (download ? '&dl=1' : '');
}

export function usePrivateDocs() {
  return !!useSelector(s => s.auth.user?.organization?.settings?.privateDocuments);
}

// <img src> / <a href> uchun manzil: yopiq hujjat bo'lsa imzolangan, aks holda oddiy
export function useMediaSrc(u) {
  const priv = usePrivateDocs();
  const needsSign = priv && isDocumentUrl(u);
  const [src, setSrc] = useState(needsSign ? '' : mediaUrl(u));
  useEffect(() => {
    if (!needsSign) { setSrc(mediaUrl(u)); return undefined; }
    let alive = true;
    signedMediaUrl(u).then(s => alive && setSrc(s)).catch(() => alive && setSrc(''));
    return () => { alive = false; };
  }, [u, needsSign]);
  return src;
}

// Havolani bosganda: yopiq hujjat bo'lsa imzolab yangi oynada ochadi (onClick uchun)
export function openMediaHandler(priv, u, { download = false } = {}) {
  return (e) => {
    if (!priv || !isDocumentUrl(u)) return;   // oddiy havola o'z ishini qiladi
    e.preventDefault();
    const win = window.open('', '_blank');
    signedMediaUrl(u, { download })
      .then(s => { if (win) win.location.href = s; else window.location.href = s; })
      .catch(() => { if (win) win.close(); });
  };
}

// Ilova darajasida: yopiq hujjatga olib boruvchi har qanday <a> bosilganda — imzolangan havola bilan ochish.
// Shunda har bir sahifadagi havolalarni alohida o'zgartirish shart emas.
export function usePrivateDocLinks() {
  const priv = usePrivateDocs();
  useEffect(() => {
    if (!priv) return undefined;
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || !isDocumentUrl(a.href) || a.href.includes('sig=')) return;
      e.preventDefault();
      e.stopPropagation();
      const download = /[?&]dl=1/.test(a.href);
      openMediaHandler(true, a.href.split('?')[0], { download })({ preventDefault() {} });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [priv]);
}

// Hujjat rasmi (preview) — yopiq bo'lsa imzolangan manzil bilan
export function MediaImg({ url, ...props }) {
  const src = useMediaSrc(url);
  return src ? React.createElement('img', { src, ...props }) : null;
}
